export function shopTracking(userId: string, trackingId: string, target: string) {
  return fetch(`/gd/tracking?key=enterPayment&user_id=${userId}&target=${target}&element=${trackingId}`, {
    credentials: 'same-origin',
  })
}
